// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__usNRh","logo":"SideDrawer_logo__+JE-b","link":"SideDrawer_link__16naB"};